module.exports = __webpack_public_path__ + "img/t1-email.0495153e.png";